import { IUserResellerMapping } from "../main/modules/foundation/_models/IUserResellerMapping";
import { IUserResellerMappingQueryOptions } from "../main/modules/foundation/_models/IUserResellerMappingQueryOptions";

export class UserResellerMappingService {
    static $inject = ["$q", "$http"];

    constructor(private readonly $q: angular.IQService, private readonly $http: angular.IHttpService) { }

    getMappings(options: IUserResellerMappingQueryOptions = {}): angular.IPromise<IUserResellerMapping[]> {
        return this
            .$http<IUserResellerMapping[]>({
                url: `/api/foundation/userResellerMappings`,
                method: "GET",
                params: { options }
            })
            .then(response => {
                return response.data;
            });
    }

    getCurrentUserMappings(): angular.IPromise<IUserResellerMapping[]> {
        return this
            .$http<IUserResellerMapping[]>({
                url: `/api/foundation/userResellerMappings/current`,
                method: "GET"
            })
            .then(response => {
                return response.data;
            });
    }
}
